import React from 'react';
import ReactDOM from 'react-dom';
import { Dialog, DialogTitle, DialogActions, DialogContent, Divider, Typography, Button, ThemeProvider, StyledEngineProvider } from '@mui/material';

import theme from '../../../assets/theme'
import { getSession } from '../../../auth';
import ReportExportData from './report_export_data';
import './large_range_dialog.css';

const TEXTS = {
    'large-range': {
        title: 'Período muito longo',
        message: 'Você selecionou um período maior que 6 meses. Consultas desse tamanho podem demorar e exceder o tempo limite. Recomendamos exportar o relatório e recebê-lo por e-mail.'
    },
    'timeout': {
        title: 'A consulta demorou demais',
        message: 'O relatório não pôde ser exibido porque a consulta excedeu o tempo limite. Você pode exportá-lo e recebê-lo por e-mail.'
    }
}

/* Render a component outside the report tree (callers of get_report_data have no setParent).
   Returns a function that unmounts it. */
const mount = (renderElement) => {
    const container = document.createElement('div')
    // Above the Loading overlay (z-index 10000)
    Object.assign(container.style, { position: 'fixed', inset: '0', zIndex: '10001' })
    document.body.appendChild(container)
    document.body.classList.add('report-choice-open')

    const unmount = () => {
        ReactDOM.unmountComponentAtNode(container)
        container.remove()
        if (!document.querySelector('.report-choice-container'))
            document.body.classList.remove('report-choice-open')
    }
    container.className = 'report-choice-container'

    ReactDOM.render((
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                {renderElement(unmount)}
            </ThemeProvider>
        </StyledEngineProvider>
    ), container)

    return unmount
}

/* Ask the user what to do with a report that is too big / timed out.
   Resolves 'export-csv' | 'export-xlsx' | 'display' | 'cancel' */
export const askReportChoice = (mode) => {
    const texts = TEXTS[mode]

    return new Promise((resolve) => {
        mount((unmount) => {
            const choose = (choice) => {
                unmount()
                resolve(choice)
            }
            return (
                <Dialog open={true} disablePortal disableEnforceFocus sx={{ position: 'absolute' }}
                    onClose={() => choose('cancel')}>
                    <DialogTitle>{texts.title}</DialogTitle>
                    <Divider />
                    <DialogContent>
                        <Typography fontSize="12px" fontWeight="500" color="#21446c">
                            {texts.message}
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ padding: "0px 20px 10px 0px" }}>
                        <Button onClick={() => choose('cancel')}>{mode === 'timeout' ? 'Fechar' : 'Cancelar'}</Button>
                        {mode === 'large-range' &&
                            <Button onClick={() => choose('display')}>Exibir mesmo assim</Button>}
                        <Button onClick={() => choose('export-csv')}>Exportar CSV</Button>
                        <Button variant="contained" onClick={() => choose('export-xlsx')}>Exportar XLSX</Button>
                    </DialogActions>
                </Dialog>
            )
        })
    })
}

/* Open the regular e-mail export dialog for the given report state, e-mail pre-filled */
export const openExportDialog = (parent, type) => {
    mount((unmount) => (
        <ReportExportData
            parent={{ ...parent, visibilityModel: parent.visibilityModel || {} }}
            setParent={() => {}}
            type={type}
            defaultEmail={getSession()?.email || ''}
            onClose={unmount}
        />
    ))
}
